import FeaturesPlateItem from './FeaturesPlateItem'

export default FeaturesPlateItem
